import classNames from "classnames";
import fr from 'date-fns/locale/fr';
import * as React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { hot } from "react-hot-loader";
import { ICustomInputProps } from './ICustomInputProps';
import PCSInput from '../PCSInput/PCSInput';

import { ITerm } from '../PCSInput/IPCSInputProps';
import { th } from "date-fns/esm/locale";

registerLocale("fr", fr);

declare var libelle: any;

//var terms: ITerm[];

class CustomInput extends React.Component<ICustomInputProps, {}> {

    constructor(props: any) {
        super(props);

        this.onPaste = this.onPaste.bind(this);     
        //terms = [{ _termName: "choix1", _childTerms: [{ _termName: "choix1_1", _childTerms: [] }] }, { _termName: "choix2", _childTerms: [{ _termName: "choix2_1", _childTerms: [] }] }]
    }

  public render() {

        const inputIsValid = this.props.InputForm.IsValid;
        const inputIsEmptyAndNotRequired = this.props.InputForm.IsEmptyAndNotRequired;

        const controlClass = classNames('form-control collapse show',
            { 'is-invalid': !inputIsValid && !inputIsEmptyAndNotRequired, 'is-valid': inputIsValid && !inputIsEmptyAndNotRequired }
        );

        const controlCheckClass = classNames('form-check-input',
            { 'is-invalid': !inputIsValid && !inputIsEmptyAndNotRequired, 'is-valid': inputIsValid && !inputIsEmptyAndNotRequired }
        );

        const controlFileClass = classNames('form-control-file',
            { 'is-invalid': !inputIsValid && !inputIsEmptyAndNotRequired, 'is-valid': inputIsValid && !inputIsEmptyAndNotRequired }
        );

        let choices: any;
        if (this.props.InputForm.Type === "Choice" && this.props.InputForm.Choices != null) {
            const choicesList: string[] = this.props.InputForm.Choices.split(";");
            if (this.props.InputForm.TypeChoices != null && this.props.InputForm.TypeChoices === "RadioButtons") {
                choices = choicesList.map((choice, key) => {
                    return (
                        <div className="form-check" key={key}>
                            <input type="radio" className={controlCheckClass} id={this.props.InputForm.Name + '_' + choice}
                                value={choice} onChange={this.props.HandleCheck}
                                name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                defaultChecked={this.props.InputForm.Value === choice} disabled={this.props.InputForm.IsReadOnly} />
                            <label className="form-check-label" htmlFor={this.props.InputForm.Name + '_' + choice}>{choice}</label>
                        </div>
                    );
                });
            } else {
                choices = choicesList.map((choice, key) => {
                    return (
                        <option key={key} value={choice}>{choice}</option>
                    );
                });
            }
        }

        const inputLabel = this.props.InputForm.Label + "&nbsp;" + (this.props.InputForm.InputValidation.IsRequired ? '*' : '');
        return (
            <div className="form-group">
                <label htmlFor={this.props.InputForm.Name} className="font-weight-bold" dangerouslySetInnerHTML={{ __html: inputLabel }} />
                {(() => {
                    switch (this.props.InputForm.Type) {
                        case "Choice":
                            switch (this.props.InputForm.TypeChoices) {
                                case "RadioButtons":
                                    return (
                                        <div>
                                            {choices}
                                        </div>
                                    );
                                default:
                                    return (
                                        <select className={controlClass} id={this.props.InputForm.Name} placeholder={this.props.InputForm.PlaceHolder}
                                            value={this.props.InputForm.Value} onChange={this.props.HandleCheck} disabled={this.props.InputForm.IsReadOnly}
                                            name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                            onPaste={this.onPaste} autoComplete={this.props.InputForm.DisabledAutoComplet ? 'off' : ''} >
                                            <option value="" />
                                            {choices}
                                        </select>
                                    );
                            }
                        case "DateTime":
                            let openToDateValue = new Date();
                            let maxDateValue: Date | null = null;
                            if (this.props.InputForm.InternalName === "DateNaissance") {
                                maxDateValue = new Date();
                                if (this.props.InputForm.Value == null || this.props.InputForm.Value === "") {
                                    openToDateValue = new Date("01/01/2000");
                                } else {
                                    openToDateValue = this.props.InputForm.Value;
                                }
                            }
                            /* Disabled typing in input DatePicker */
                            const handleDateChangeRaw = (e) => {
                                e.preventDefault();
                            }
                            return (
                                <div>
                                    <DatePicker className={controlClass} readOnly={this.props.InputForm.IsReadOnly} dateFormat="dd/MM/yyyy" locale="fr"
                                        name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired} maxDate={maxDateValue}
                                        dropdownMode="select" peekNextMonth={true} showMonthDropdown={true} showYearDropdown={true}
                                        selected={this.props.InputForm.Value} onSelect={this.props.HandleChangeDate} openToDate={openToDateValue}
                                        onChangeRaw={handleDateChangeRaw}
                                    />
                                </div>
                            );
                        case "Boolean":
                            return (
                                <div>
                                    <div className="form-check">
                                        <input type="radio" className={controlCheckClass} id={this.props.InputForm.Name + '_yes'}
                                            value="true" onChange={this.props.HandleCheck} 
                                            name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                            defaultChecked={this.props.InputForm.Value === "True"} disabled={this.props.InputForm.IsReadOnly} />
                                        <label className="form-check-label" htmlFor={this.props.InputForm.Name + '_yes'}>oui</label>
                                    </div>
                                    <div className="form-check">
                                        <input type="radio" className={controlCheckClass} id={this.props.InputForm.Name + '_no'}
                                            value="false" onChange={this.props.HandleCheck} 
                                            name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                            defaultChecked={this.props.InputForm.Value === "False"} disabled={this.props.InputForm.IsReadOnly} />
                                        <label className="form-check-label" htmlFor={this.props.InputForm.Name + '_no'}>non</label>
                                    </div>
                                </div>
                            );
                        case "File":
                            const disabledInputFile = this.props.OnDelete || this.props.OnDownload || this.props.OnUpload;
                            return (
                                <div>
                                    <div className="d-flex flex-row">
                                        {this.props.OnUpload &&
                                            <span className="spinner-border spinner-border-sm mr-1 align-self-center" role="status" aria-hidden="true" />
                                        }
                                        <div className="custom-file">
                                            <input type="file" className={"custom-file-input " + controlFileClass} id={this.props.InputForm.Name} lang="fr" 
                                            onChange={this.props.HandleChange} name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                            disabled={this.props.InputForm.IsReadOnly || disabledInputFile} aria-describedby="fileHelp" />
                                            <label className="custom-file-label" htmlFor="customFile">{this.props.InputForm.FileName}</label>
                                        </div>
                                    </div>
                                    {this.props.FileExist &&
                                        <small id="fileHelp" className="form-text fileExist">{libelle.customInput.fileExist}</small>
                                    }
                                    {!this.props.FileExist &&
                                        <small id="fileHelp" className="form-text text-muted">{libelle.customInput.fileNotExist}</small>
                                    }
                                    {this.props.InputForm.InputValidation.IsExtensions != null &&
                                        <small id="fileHelp" className="form-text text-muted">{libelle.customInput.acceptedFormat}&nbsp;{this.props.InputForm.InputValidation.IsExtensions.join(', ')}</small>
                                    }
                                </div>
                            );
                        case "Note":
                            return (
                                <textarea className={controlClass} id={this.props.InputForm.Name} placeholder={this.props.InputForm.PlaceHolder}
                                    value={this.props.InputForm.Value} onChange={this.props.HandleChange} readOnly={this.props.InputForm.IsReadOnly}
                                    name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                    onPaste={this.onPaste} autoComplete={this.props.InputForm.DisabledAutoComplet ? 'off' : ''} onBlur={this.props.HandleBlur} />
                            );
                        case "password":
                            return (
                                <input type="password" className={controlClass} id={this.props.InputForm.Name} placeholder={this.props.InputForm.PlaceHolder}
                                    value={this.props.InputForm.Value} onChange={this.props.HandleChange} readOnly={this.props.InputForm.IsReadOnly}
                                    name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                    onPaste={this.onPaste} autoComplete={this.props.InputForm.DisabledAutoComplet ? 'off' : ''} onBlur={this.props.HandleBlur} />
                            );

                      case "TaxonomyFieldType":
                                               
                        let inputlistesSP: string[] = [];
                        if (this.props.InputForm.Name == "PCSParent1") {
                            inputlistesSP = ["ProfPCSParent1","FonctionParent1"];
                        }
                        if (this.props.InputForm.Name == "PCSParent2") {
                              inputlistesSP = ["ProfPCSParent2","FonctionParent2"];
                        }

                        return (

                          <PCSInput _terms={this.props.InputForm.Terms} CustomInputProps={this.props} inputListeSP={inputlistesSP}
                            onChange={this.props.HandleCheck} init={this.props.InitListePCS} />

                        );

                        default:
                            return (
                                <input type="text" className={controlClass} id={this.props.InputForm.Name} placeholder={this.props.InputForm.PlaceHolder}
                                    value={this.props.InputForm.Value} onChange={this.props.HandleChange} readOnly={this.props.InputForm.IsReadOnly}
                                    name={this.props.InputForm.Name} required={this.props.InputForm.InputValidation.IsRequired}
                                    onPaste={this.onPaste} autoComplete={this.props.InputForm.DisabledAutoComplet ? 'off' : ''} onBlur={this.props.HandleBlur} />
                            );
                    }
                })()}
                <input type="hidden" className={controlFileClass} />
                <span className="invalid-feedback">{this.props.InputForm.Message}</span>
            </div>
        );
    }

    private onPaste(event) {

        if (this.props.InputForm.DisabledPaste) {
            event.preventDefault();
        }

    }

}

export default hot(module)(CustomInput);
